import * as commonConsts from '../../../../pages/common/CommonConsts';

const documentUploads = [
  {
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange },
      { type: commonConsts.DOC_UPLOAD_TYPE_Other }
    ]
  }
];

const getDocumentError = (errors, documentUploadType) => {
  if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange) {
    return errors.hasChangeOfNameCertificateDocument;
  }
};

export { documentUploads, getDocumentError };
